package com.tovtalk.utils.strings

import kotlinx.browser.window
import kotlinx.coroutines.await

private var cachedTranslations: MutableMap<String, String?> = mutableMapOf()

actual fun readBundledTranslationsJson(languageCode: String): String? {
    // Return cached if available (sync call - translations must be preloaded)
    return cachedTranslations[languageCode]
}

actual suspend fun ensureBundledTranslationsLoaded(languageCode: String) {
    val lang = if (languageCode == "he") "he" else "en"
    if (cachedTranslations[lang] != null) return
    preloadTranslationsForWeb(lang)
}

/**
 * Preload translations JSON from the server (must be called before StringProvider is used).
 * The JSON files are served as static assets alongside the app.
 */
suspend fun preloadTranslationsForWeb(languageCode: String): String? {
    val lang = if (languageCode == "he") "he" else "en"
    return try {
        val response = window.fetch("/$lang.json").await()
        if (response.ok) {
            val text = response.text().await() as String
            cachedTranslations[lang] = text
            text
        } else {
            null
        }
    } catch (_: Throwable) {
        null
    }
}
